export type MetadataExample = {
	documentDescription: string;
	executionDate: string;
};
